module.exports = __webpack_public_path__ + "static/media/bed.1ff9626e.svg";